import { useEffect, useState } from "react";
import { fetchLeads } from "@/lib/api";
import { Loader2, Home as HomeIcon } from "lucide-react";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeads().then(setLeads).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12">
        <div className="flex items-center justify-between mb-8">
          <div>
            <p className="overline text-kw-red">Internal Dashboard</p>
            <h1 className="font-serif text-4xl tracking-tight text-kw-ink">Leads</h1>
          </div>
          <a href="/" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-kw-red transition-colors">
            <HomeIcon size={15} /> Back to site
          </a>
        </div>

        {loading ? (
          <div className="flex items-center gap-2 text-neutral-500"><Loader2 className="animate-spin" size={18} /> Loading…</div>
        ) : leads.length === 0 ? (
          <p className="text-neutral-500" data-testid="no-leads">No leads yet.</p>
        ) : (
          <div className="border border-neutral-200 bg-white overflow-x-auto" data-testid="leads-table">
            <table className="w-full text-sm">
              <thead className="bg-kw-ink text-white text-left">
                <tr>
                  {["Type", "Name", "Email", "Phone", "Address", "Intent", "Message", "When"].map((h) => (
                    <th key={h} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leads.map((l) => (
                  <tr key={l.id} className="border-t border-neutral-200 align-top">
                    <td className="px-4 py-3"><span className="bg-kw-red/10 text-kw-red px-2 py-0.5 text-xs font-semibold">{l.lead_type}</span></td>
                    <td className="px-4 py-3 font-medium whitespace-nowrap">{l.name}</td>
                    <td className="px-4 py-3 whitespace-nowrap">{l.email}</td>
                    <td className="px-4 py-3 whitespace-nowrap">{l.phone || "—"}</td>
                    <td className="px-4 py-3">{l.address || "—"}</td>
                    <td className="px-4 py-3">{l.intent || "—"}</td>
                    <td className="px-4 py-3 max-w-[220px]">{l.message || "—"}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-neutral-500">{new Date(l.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
